import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import { Mercado } from "../models/enum";
import { OperacaoLeitorBMF, OperacaoLeitorBovespa } from "../models/operacao";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class OperacaoDb extends BaseDb<
  OperacaoLeitorBovespa | OperacaoLeitorBMF,
  { usuarioId: string; operacaoId: string }
> {
  _path: string = "usuarios/usuarioId/operacoes/operacaoId";
  getConverter(): FirestoreDataConverter<
    OperacaoLeitorBovespa | OperacaoLeitorBMF
  > {
    return {
      fromFirestore: (snapshot) => {
        if (snapshot.get("mercado") === Mercado.FUTUROS) {
          return new OperacaoLeitorBMF({
            codigoAtivo: snapshot.get("codigoAtivo"),
            mercado: snapshot.get("mercado"),
            tipoOperacao: snapshot.get("tipoOperacao"),
            quantidade: snapshot.get("quantidade"),
            precoUnitario: snapshot.get("precoUnitario"),
            daytradeSwingtrade: snapshot.get("daytradeSwingtrade"),
            prazo: moment.tz(
              snapshot.get("prazo").toDate(),
              "America/Sao_Paulo"
            ),
            tipoNegocio: snapshot.get("tipoNegocio"),
            taxaOperacional: snapshot.get("taxaOperacional"),
            valorOperacao: snapshot.get("valorOperacao"),
            debitoCredito: snapshot.get("debitoCredito"),
            ordem: snapshot.get("ordem"),
            nota: snapshot.get("nota"),
            usuario: snapshot.get("usuario"),
            dataPregao: moment.tz(
              snapshot.get("dataPregao").toDate(),
              "America/Sao_Paulo"
            ),
          });
        } else {
          return new OperacaoLeitorBovespa({
            codigoAtivo: snapshot.get("codigoAtivo"),
            mercado: snapshot.get("mercado"),
            tipoOperacao: snapshot.get("tipoOperacao"),
            quantidade: snapshot.get("quantidade"),
            precoUnitario: snapshot.get("precoUnitario"),
            daytradeSwingtrade: snapshot.get("daytradeSwingtrade"),
            valorTotal: snapshot.get("valorTotal"),
            prazo: snapshot.get("prazo")
              ? moment.tz(snapshot.get("prazo").toDate(), "America/Sao_Paulo")
              : undefined,
            codigoObjeto: snapshot.get("codigoObjeto"),
            isinAtivo: snapshot.get("isinAtivo"),
            ordem: snapshot.get("ordem"),
            nota: snapshot.get("nota"),
            usuario: snapshot.get("usuario"),
            dataPregao: moment.tz(
              snapshot.get("dataPregao").toDate(),
              "America/Sao_Paulo"
            ),
          });
        }
      },
      toFirestore: toFirestore,
    };
  }
}
